const defaultApiBaseUrl = "https://localhost:44304/api/";

function trimTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

function ensureTrailingSlash(value) {
  const trimmed = trimTrailingSlash(value);
  return trimmed ? `${trimmed}/` : "";
}

const runtimeConfig = window.__APP_CONFIG__ || {};
const configuredApiBaseUrl = runtimeConfig.API_BASE_URL || defaultApiBaseUrl;

export const API_BASE_URL = ensureTrailingSlash(configuredApiBaseUrl);
export const API_ORIGIN_URL = trimTrailingSlash(API_BASE_URL.replace(/\/api\/?$/i, ""));

// Full URLs and root-relative paths are used as-is; anything else is a file under public/.
function resolvePublicUrl(value) {
  if (/^(https?:|data:|\/)/i.test(value)) {
    return value;
  }
  return `${trimTrailingSlash(process.env.PUBLIC_URL)}/${value}`;
}

export const BRAND = {
  name: runtimeConfig.BRAND_NAME || "Smart Auto",
  appName: runtimeConfig.APP_NAME || "Product Identification System",
  tagline: runtimeConfig.APP_TAGLINE || "Find products, browse spares and raise requests - all in one place.",
  pageTitle: runtimeConfig.PAGE_TITLE || "Smart Auto | Product Catalog",
  logoUrl: resolvePublicUrl(runtimeConfig.LOGO_URL || "brand/smartauto/logo.png"),
  loginBgUrl: resolvePublicUrl(runtimeConfig.LOGIN_BG_URL || "brand/smartauto/login-bg.png"),
  faviconUrl: resolvePublicUrl(runtimeConfig.FAVICON_URL || "favicon.ico")
};

